<template>
  <div>
    <DisableCollege
      :value="confirmDisable.modal"
      title="El servicio de skolable se encuentra suspendido para tu colegio, para obtener más detalles acerca de la suspensión, envía un correo a"
      :description="msgDisable.error_description"
      v-on:desition="confirmDisableEvent"
    />
  </div>
</template>

<script>
import DisableCollege from './DisableCollege.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    DisableCollege,
  },
  data() {
    return {
      confirmDisable: {
        modal: true,
      },
    }
  },
  computed:{
    ...mapGetters({
      msgDisable: "getMsgDisableCollege"
    })
  },
  methods:{
    confirmDisableEvent(confirm){
        if(confirm){
            this.$router.push("login");
            this.confirmDisable.modal = false

        }      
            this.$router.push("login");
            this.confirmDisable.modal = false
    }
  }
}
</script>
